module.exports = __webpack_public_path__ + "static/media/LT3-BG4.7245376d.jpg";